import React, {useContext} from "react";
import {
    TreeContext,
    AttributeContext,
    DialogContext,
    SiteColorContext, TokenContext, RealmContext,
} from "../../Store";

// Attr-Merkmale zeigen
import EditAttr from "./EditAttr";
// Bauteil anlegen Dialog
import CreateCompDialog from "./Dialog/CreateComp/CreateSubCompDialog";
// Bauteil updaten Dialog
import UpdateCompDialog from "./Dialog/UpdateComp/UpdateCompDialog";
// Bauteil löschen Dialog
import DeleteCompDialog from "./Dialog/DeleteComp/DeleteCompDialog";
// Attribut anlegen Dialog
import CreateAttrDialog from "./Dialog/CreateAttr/CreateAttrDialog";
// Attribut updaten Dialog
import UpdateAttrDialog from "./Dialog/UpdateAttr/UpdateAttrDialog";
// Attribut löschen Dialog
import DeleteAttrDialog from "./Dialog/DeleteAttr/DeleteAttrDialog";

import {makeStyles} from "@mui/styles"
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import IconButton from "@mui/material/IconButton";
import CreateIcon from "@mui/icons-material/Create";
import DeleteIcon from "@mui/icons-material/Delete";
import TreeComponentTypeService from "../../../services/TreeComponentTypeService";
import RenderOnRole from "../../RenderOnRole";
import http from "../../../shared/http-common";

import DropdownWithAutocomplete from '../../../shared/DropdownWithAutocomplete';
import ArrowRightIcon from "@mui/icons-material/ArrowRight";

// Bauteil-Informationen darstellen, inkl. aller Dialoge zum Bearbeiten

const useStyles = makeStyles({
    root: {
        textAlign: "left",
        width: "100%",
        overflow: "hidden",
    },
    buttonLight: {
        float: "right",
        fontWeight: "bold",
        marginRight: 20,
    },
    buttonDark: {
        float: "right",
        fontWeight: "bold",
        marginRight: 20,
        color: "#e5e5e5",
    },
    create: {
        float: "right",
        textAlign: "right",
    },
    btEdit: {
        width: "70%",
        height: "90%",
        margin: "15px",
        padding: "20px",
        float: "left",
        border: "1px solid #4D6F8C",
        borderRadius: "25px",
    },
    btEditBtn: {
        float: "right",
        textAlign: "right",
        flexGrow: "1",
    },
    btInfo: {
        display: "flex",
    },
    btDesc: {
        flexGrow: "7",
    },
    btUeber: {
        float: "left",
        textAlign: "left",
        fontSize: "18px",
        fontWeight: "bold",
        width: "100%",
    },
    btDetail: {
        float: "left",
        textAlign: "left",
        padding: "5px",
        width: "100%",
    },
    attrView: {
        width: "1 rem",
        minHeight: "fit-content",
        maxHeight: "65vh",
        display: "flex",
        alignItems: "left",
        padding: "5px",
        border: "1px solid #4D6F8C",
        borderRadius: "25px",
        overflowY: "auto",
        overflowX: "hidden",
    },
    attrListe: {
        width: "20vw",
        maxHeight: "55vh",
        overflowY: "auto",
        overflowX: "hidden",
        float: "left",
    },
    headlineBearbeiten: {
        textAlign: "left",
        fontWeight: "bold",
        margin: "5px",
    },
    lightIcons: {
        color: "grey",
    },
    darkIcons: {
        color: "#e5e5e5",
    },
});

// Attribute als TreeItem definieren
function TreeItemsFromDataAttr({ arrayItems }) {
    const attribute = useContext(AttributeContext);

    return arrayItems.map((treeItemData) => (
        <TreeItem
            key={treeItemData.name}
            itemId={treeItemData.name}
            label={treeItemData.name}
            onClick={() => {
                attribute.setSelected(treeItemData);
                attribute.setIsSelected(true);
            }}
        />
    ));
}

// Baumdarstellung Attributliste
function DataTreeViewAttr({ arrayItems }) {
    const classes = useStyles();
    return (
        <SimpleTreeView
            className={classes.root}
            slots={{ collapseIcon: ExpandMoreIcon, expandIcon: ChevronRightIcon, endIcon: ArrowRightIcon }}
        >
            <TreeItemsFromDataAttr arrayItems={arrayItems} />
        </SimpleTreeView>
    );
}

export default function EditComp() {
    const [token] = useContext(TokenContext);
    const [realm] = useContext(RealmContext);
    const tree = useContext(TreeContext);
    const attribute = useContext(AttributeContext);
    const dialog = useContext(DialogContext);
    const [SiteColor] = useContext(SiteColorContext);
    const TreeSelected = tree.selected;
    const TreeSelectedItem = tree.selectedItem;
    const classes = useStyles();

    const reloadTreeItem = async () => {
        if (!TreeSelected.code) return;
        const result = await TreeComponentTypeService.getTreeComponent(token, realm, TreeSelected.code);
        if (result?.data instanceof Array && result.data.length > 0) {
            tree.setSelectedItem(result.data[0].attribute);
            return result.data;
        }
    };

    const fetchAutocompleteData = async (selectedValue) => {
        try {
            const formData = new FormData();
            formData.append("realm", realm);
            return await http.post(`/realestateobject/${selectedValue}/list`, formData, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + token
                }
            });
        } catch (e) {
            console.error(e);
            throw e;
        }
    };

    return (
        <div className={classes.btEdit}>
            <div className={classes.btInfo}>
                <div className={classes.btDesc}>
                    <div className={classes.btUeber}>{TreeSelected.name}</div>
                    <div className={classes.btDetail}>
                        <p>
                            <b>Beschreibung:</b> {TreeSelected.description}
                        </p>
                        <p>
                            <b>Bauteil-Code:</b> {TreeSelected.code}
                        </p>
                    </div>
                </div>
                <RenderOnRole roles={['MAP_ADMIN', 'ADMIN_MAP', 'TWIN_DATA_ADMIN']}>
                {TreeSelected.twin_only ? SiteColor ? (
                    <div className={classes.btEditBtn}>
                        <IconButton
                            className={classes.lightIcons}
                            onClick={() => dialog.setUpdateCompOpen(true)}
                        >
                            <CreateIcon />
                        </IconButton>
                        <IconButton
                            className={classes.lightIcons}
                            onClick={() => dialog.setDeleteCompOpen(true)}
                        >
                            <DeleteIcon />
                        </IconButton>
                    </div>
                ) : (
                    <div className={classes.btEditBtn}>
                        <IconButton
                            className={classes.darkIcons}
                            onClick={() => dialog.setUpdateCompOpen(true)}
                        >
                            <CreateIcon />
                        </IconButton>
                        <IconButton
                            className={classes.darkIcons}
                            onClick={() => dialog.setDeleteCompOpen(true)}
                        >
                            <DeleteIcon />
                        </IconButton>
                    </div>
                ) : null }
                </RenderOnRole>
            </div>
            <div className={classes.attrView}>
                <div className={classes.attrListe}>
                    <div className={classes.headlineBearbeiten}>Merkmale:</div>
                    <DataTreeViewAttr arrayItems={TreeSelectedItem} />
                    <div>
                        <RenderOnRole roles={['MAP_ADMIN', 'ADMIN_MAP', 'TWIN_DATA_ADMIN']}>
                            <div>
                                <button onClick={() => dialog.setOpen(true)} hidden>
                                    Komponente hinzufügen
                                </button>
                                {SiteColor ? (
                                    <Button
                                        className={classes.buttonLight}
                                        onClick={() => dialog.setAttrOpen(true)}
                                    >
                                        <AddIcon /> Neu
                                    </Button>
                                ) : (
                                    <Button
                                        className={classes.buttonDark}
                                        onClick={() => dialog.setAttrOpen(true)}
                                    >
                                        <AddIcon /> Neu
                                    </Button>
                                )}
                            </div>
                        </RenderOnRole>
                    </div>
                </div>
                {attribute.isSelected ? <EditAttr /> : null}
                <CreateCompDialog />
                <UpdateCompDialog />
                <DeleteCompDialog />
                <CreateAttrDialog reloadTreeItem={reloadTreeItem}/>
                <UpdateAttrDialog reloadTreeItem={reloadTreeItem}/>
                <DeleteAttrDialog reloadTreeItem={reloadTreeItem}/>
            </div>
            <div style={{textAlign: "left", marginTop: "10px"}}>
                <DropdownWithAutocomplete
                    TreeSelected={TreeSelected}
                    fetchAutocompleteData={fetchAutocompleteData}
                    realm={realm}
                    token={token}
                />
            </div>
        </div>
    );
}
